import { getPaqueteOferta, newOfertaPaquete, updateOfertaPaquete } from "../services/servicePaquete"

const dataInicial = {
    listOfertaPaquete: [],
    totalOfertaPaquete: 0,
    exito: 0,
    pagina: 0,
    registros: 10,
    clavePaquete: "",
    openModal: false,
    editar: false,
    oferta: {},
}

const GET_OFERTA_PAQUETE_ACTION = "GET_OFERTA_PAQUETE_ACTION"
const GET_OFERTA_PAQUETE_PAGINA_ACTION = "GET_OFERTA_PAQUETE_PAGINA_ACTION"
const GET_OFERTA_PAQUETE_REGISTROS_ACTION = "GET_OFERTA_PAQUETE_REGISTROS_ACTION"
const POST_OFERTA_PAQUETE_ACTION = "POST_OFERTA_PAQUETE_ACTION"
const PUT_OFERTA_PAQUETE_ACTION = "PUT_OFERTA_PAQUETE_ACTION"
const OPEN_OFERTA_PAQUETE_ACTION = "OPEN_OFERTA_PAQUETE_ACTION"
const CLOSE_OFERTA_PAQUETE_ACTION = "CLOSE_OFERTA_PAQUETE_ACTION"
const OPEN_EDITAR_OFERTA_PAQUETE_ACTION = "OPEN_EDITAR_OFERTA_PAQUETE_ACTION"
const CLOSE_EDITAR_OFERTA_PAQUETE_ACTION = "CLOSE_EDITAR_OFERTA_PAQUETE_ACTION"

export default function ofertasPaqueteReducer(state = dataInicial, action) {
    switch (action.type) {
        case GET_OFERTA_PAQUETE_ACTION:
            return { ...state, listOfertaPaquete: action.payload.listOfertaPaquete, totalOfertaPaquete: action.payload.totalOfertaPaquete }
        case GET_OFERTA_PAQUETE_PAGINA_ACTION:
            return { ...state, listOfertaPaquete: action.payload.listOfertaPaquete, totalOfertaPaquete: action.payload.totalOfertaPaquete, pagina: action.payload.pagina }
        case GET_OFERTA_PAQUETE_REGISTROS_ACTION:
            return { ...state, listOfertaPaquete: action.payload.listOfertaPaquete, totalOfertaPaquete: action.payload.totalOfertaPaquete, registros: action.payload.registros }
        case POST_OFERTA_PAQUETE_ACTION:
        case PUT_OFERTA_PAQUETE_ACTION:
            return { ...state, exito: action.payload.exito }
        case OPEN_OFERTA_PAQUETE_ACTION:
        case CLOSE_OFERTA_PAQUETE_ACTION:
            return { ...state, clavePaquete: action.payload.clavePaquete, openModal: action.payload.openModal }
        case CLOSE_EDITAR_OFERTA_PAQUETE_ACTION:
        case OPEN_EDITAR_OFERTA_PAQUETE_ACTION:
            return { ...state, editar: action.payload.editar, oferta: action.payload.oferta }
        default:
            return state
    }
}

export const obtenerOfertasPaqueteAction = ({ clavePaquete }) => async (dispatch) => {
    return await getPaqueteOferta({ clavePaquete: clavePaquete, pagina: dataInicial.pagina + 1, registros: dataInicial.registros }).then(Response => {
        dispatch({
            type: GET_OFERTA_PAQUETE_ACTION,
            payload: {
                listOfertaPaquete: Response.lPaqueteOferta,
                totalOfertaPaquete: Response.total,
            }
        })
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerOfertasPaquetePaginaAction = ({ pagina }) => async (dispatch, getState) => {
    const { clavePaquete, registros } = getState().ofertasPaquete
    return await getPaqueteOferta({ clavePaquete, pagina: pagina + 1, registros }).then(Response => {
        dispatch({
            type: GET_OFERTA_PAQUETE_PAGINA_ACTION,
            payload: {
                listOfertaPaquete: Response.lPaqueteOferta,
                totalOfertaPaquete: Response.total,
                pagina
            }
        })
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerOfertasPaqueteRegistrosAction = ({ registros }) => async (dispatch, getState) => {
    const { clavePaquete, pagina } = getState().ofertasPaquete
    return await getPaqueteOferta({ clavePaquete, pagina: pagina + 1, registros }).then(Response => {
        dispatch({
            type: GET_OFERTA_PAQUETE_REGISTROS_ACTION,
            payload: {
                listOfertaPaquete: Response.lPaqueteOferta,
                totalOfertaPaquete: Response.total,
                registros
            }
        })
        return Response
    }).catch(Error => {
        return {}
    })
}
export const nuevoOfertaPaqueteAction = ({ cantidad, descripcion, fechaFin, fechaInicio, operacion }) => async (dispatch, getState) => {
    const { clavePaquete } = getState().ofertasPaquete
    return await newOfertaPaquete({ cantidad, clavePaquete, descripcion, fechaFin, fechaInicio, operacion }).then(Response => {
        dispatch({
            type: POST_OFERTA_PAQUETE_ACTION,
            exito: 1
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const actualizarOfertaPaqueteAction = ({ idPaqueteOferta, cantidad, descripcion, estatus, fechaFin, fechaInicio, operacion }) => async (dispatch, getState) => {
    const { clavePaquete } = getState().ofertasPaquete
    return await updateOfertaPaquete({ idPaqueteOferta, cantidad, clavePaquete, descripcion, estatus, fechaFin, fechaInicio, operacion }).then(Response => {
        dispatch({
            type: PUT_OFERTA_PAQUETE_ACTION,
            exito: 1
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const openModalOfertasPaqueteAction = ({ clavePaquete }) => (dispatch) => {
    dispatch({
        type: OPEN_OFERTA_PAQUETE_ACTION,
        payload: {
            clavePaquete: clavePaquete,
            openModal: true
        }
    })
}
export const closeModalOfertaPaqueteAction = () => (dispatch) => {
    dispatch({
        type: CLOSE_OFERTA_PAQUETE_ACTION,
        payload: {
            clavePaquete: dataInicial.clavePaquete,
            openModal: dataInicial.openModal,
        }
    })
}
export const openEditarOfertaPaqueteAction = ({ oferta }) => (dispatch) => {
    dispatch({
        type: OPEN_EDITAR_OFERTA_PAQUETE_ACTION,
        payload: {
            editar: true,
            oferta
        }
    })
}
export const closeEditarOfertaPaqueteAction = () => (dispatch) => {
    dispatch({
        type: CLOSE_EDITAR_OFERTA_PAQUETE_ACTION,
        payload: {
            editar: dataInicial.editar,
            oferta: dataInicial.oferta
        }
    })
}